"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractComponent_1 = __importDefault(require("./AbstractComponent"));
var constants_1 = require("../data/constants");
var core_1 = require("@photo-sphere-viewer/core");
var autorotate_plugin_1 = require("@photo-sphere-viewer/autorotate-plugin");
var Panorama = /** @class */ (function (_super) {
    __extends(Panorama, _super);
    function Panorama() {
        var _this = _super.call(this, constants_1.DATA_PANORAMA) || this;
        if (!_this.getElement())
            return _this;
        _this.panoramas = document.querySelectorAll("[".concat(constants_1.DATA_PANORAMA, "]"));
        _this.createPanorama();
        return _this;
    }
    Panorama.prototype.createPanorama = function () {
        this.panoramas.forEach(function (panorama) {
            var imagePath = panorama.getAttribute('data-panorama');
            new core_1.Viewer({
                container: panorama,
                panorama: imagePath,
                navbar: [
                    'autorotate',
                    'zoom',
                    'fullscreen'
                ],
                plugins: [
                    [autorotate_plugin_1.AutorotatePlugin, {
                            autostartDelay: 100
                        }]
                ]
            });
        });
    };
    return Panorama;
}(AbstractComponent_1.default));
exports.default = Panorama;
